module.exports = __webpack_public_path__ + "static/media/slider.949aac79.jpg";